export default __webpack_public_path__ + "static/media/single_conv_mppt_topology_reduced.da313691.png";